/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {EnvironmentModule} from "@modules/EnvironmentModule";
import {FONTS} from "@res/fonts";
import {COLORS} from "@res/colors";

export const VersionDisplay = () => {
	const envName = EnvironmentModule.getEnvName();
	// const version = EnvironmentModule.getAppVersion();
	return <div className={"ll_v_c"} style={{flex: 1, maxWidth: 106}}>
		{FONTS.reg_11(`${envName && envName + '-'}1.0-beta`, {color: COLORS.neutral_gray_2})}
	</div>
};
